/**
 * English: Bar chart for memory daily summaries — replaces the manual SVG TimelineChart.
 * Thai: Bar chart สำหรับ memory daily summaries — แทนที่ SVG TimelineChart เดิม
 */
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid,
} from 'recharts';

interface DailySummaryItem {
  summary_date: string;
  source_turn_count: number;
}

interface DailySummaryChartProps {
  items: DailySummaryItem[];
}

export default function DailySummaryChart({ items }: DailySummaryChartProps) {
  if (!items.length) return null;

  const sorted = [...items]
    .sort((a, b) => a.summary_date.localeCompare(b.summary_date))
    .map((item) => ({
      date: item.summary_date.slice(5),
      fullDate: item.summary_date,
      turns: item.source_turn_count,
    }));

  return (
    <ResponsiveContainer minWidth={1} minHeight={1} width="100%" height={140}>
      <BarChart data={sorted} margin={{ top: 4, right: 4, bottom: 0, left: -20 }}>
        <CartesianGrid
          strokeDasharray="3 3"
          stroke="rgb(var(--color-app-border))"
          strokeOpacity={0.4}
          vertical={false}
        />
        <XAxis
          dataKey="date"
          tick={{ fontSize: 10, fill: 'rgb(var(--color-app-text-dim))' }}
          axisLine={false}
          tickLine={false}
          interval="preserveStartEnd"
        />
        <YAxis
          tick={{ fontSize: 10, fill: 'rgb(var(--color-app-text-dim))' }}
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
        />
        <Tooltip
          contentStyle={{
            background: 'rgb(var(--color-app-surface))',
            border: '1px solid rgb(var(--color-app-border))',
            borderRadius: 8,
            fontSize: 12,
          }}
          labelFormatter={(_, payload) => payload?.[0]?.payload?.fullDate || ''}
          formatter={(value) => [`${value} turns`, 'Turns']}
        />
        <Bar
          dataKey="turns"
          fill="rgb(var(--color-app-accent))"
          radius={[3, 3, 0, 0]}
          maxBarSize={24}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
